export const DEFAULT_ANALYTICS_EVENT_KEY = 'quoteRequestCompleted'
